'use client'
import React from 'react';
import { useTranslations } from "next-intl";
import type { Blog } from "@/lib/@types/api/blog";
import { Link } from "@/navigation";

interface TagProps {
	tagList: Blog.BlogTag[];
}

const TagsCloud: React.FC<TagProps> = ({ tagList }) => {
	const t = useTranslations();
	
	return (
		<div className="overflow-hidden border border-gray-200 bg-white shadow-md md:mt-10 mt-6">
			<div className="bg-mainColor px-5 py-3">
				<h2 className="text-lg font-bold text-white flex items-center gap-2">
					<i className="ri-price-tag-3-line text-lg"></i>
					{t('blog.tags')}
				</h2>
			</div>
			<div className="p-4">
			<div className="flex items-center flex-wrap gap-3">
				{tagList.length > 0 && tagList.map((tag) => (
					<Link 
						href={`/tag/${tag.tag_slug}`} 
						key={tag.tag_id}
						className="bg-white border border-gray-200 py-2 px-4 text-gray-700 cursor-pointer capitalize hover:bg-mainColor hover:border-mainColor hover:text-white transition-all duration-200 text-sm font-medium"
					>
						{tag.tag_name}
					</Link>
				))}
			</div>
			</div>
		</div>
	);
};

export default TagsCloud;
